import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="catalog--attribute-definition-form"
// Manages conditional field visibility (measurement/entity/enum/range) based on
// data_type selection, and dynamic enum value row addition/removal.
export default class extends Controller {
  static targets = [
    "measurementFields",
    "entityFields",
    "enumFields",
    "rangeFields",
    "enumContainer",
    "rowTemplate",
  ]

  connect() {
    this._bindDataTypeChange()
    this._syncVisibility()
  }

  disconnect() {
    this._unbindDataTypeChange()
  }

  // ── Actions ──────────────────────────────────────────────────────────

  // Clone the server-rendered row template (Ui::* components) so new rows match
  // the persisted ones exactly. Seed the position with the current row count.
  addEnumValue() {
    const count =
      this.enumContainerTarget.querySelectorAll(".enum-value-row").length
    const fragment = this.rowTemplateTarget.content.cloneNode(true)
    const positionInput = fragment.querySelector(
      'input[name="item_attribute_definition[enum_values][][position]"]',
    )
    if (positionInput) positionInput.value = count
    this.enumContainerTarget.appendChild(fragment)
  }

  removeEnumValue(event) {
    event.currentTarget.closest(".enum-value-row").remove()
  }

  preventEnterSubmit(event) {
    if (
      event.key === "Enter" &&
      event.target.tagName !== "TEXTAREA" &&
      event.target.type !== "submit"
    ) {
      event.preventDefault()
    }
  }

  // ── Private ──────────────────────────────────────────────────────────

  _bindDataTypeChange() {
    const form =
      this.element.closest("form") || this.element.querySelector("form")
    if (!form) return

    this._form = form
    this._handleChangeBound = this._handleChange.bind(this)
    // Form-level delegation to work with Tom Select (ui--select controller)
    form.addEventListener("change", this._handleChangeBound)
  }

  _unbindDataTypeChange() {
    if (this._form && this._handleChangeBound) {
      this._form.removeEventListener("change", this._handleChangeBound)
    }
  }

  _handleChange(event) {
    const name = event.target?.getAttribute("name")
    if (name === "item_attribute_definition[data_type]") {
      this._syncVisibility()
    }
  }

  _syncVisibility() {
    const select =
      this.element.querySelector(
        'select[name="item_attribute_definition[data_type]"]',
      ) ||
      this._form?.querySelector(
        'select[name="item_attribute_definition[data_type]"]',
      )

    if (!select) return

    const value = select.value

    this.measurementFieldsTarget.classList.toggle(
      "hidden",
      value !== "measurement",
    )
    this.entityFieldsTarget.classList.toggle("hidden", value !== "entity")
    this.enumFieldsTarget.classList.toggle("hidden", value !== "enum")
    // CONEK-7911: a min/max range applies to integer and float only.
    if (this.hasRangeFieldsTarget) {
      this.rangeFieldsTarget.classList.toggle(
        "hidden",
        value !== "integer" && value !== "float",
      )
    }
  }
}
